import React from "react";
import {
 Modal,
 ModalOverlay,
 ModalContent,
 ModalHeader,
 ModalCloseButton,
 ModalBody,
 useDisclosure,
 Button,
 Box,
 useToast,
} from "@chakra-ui/react";
import MbbsInquiryForm from "./MbbsInquiryForm"; // make sure path is correct

const MbbsFormModal = () => {
 const { isOpen, onOpen, onClose } = useDisclosure();
 const toast = useToast();

 const handleSuccess = () => {
  onClose(); // Close the modal
  toast({
   title: "Form submitted successfully.",
   description:
    "Your inquiry has been submitted. Our team will reach out to you soon.",
   status: "success",
   duration: 5000,
   isClosable: true,
  });
 };

 return (
  <Box>
   <Button backgroundColor={"#01B4EC"} onClick={onOpen}>
    Apply Now
   </Button>

   <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
    <ModalOverlay />
    <ModalContent>
     <ModalCloseButton />
     <ModalBody>
      <MbbsInquiryForm onSuccess={handleSuccess} />
     </ModalBody>
    </ModalContent>
   </Modal>
  </Box>
 );
};

export default MbbsFormModal;

// // MbbsFormModal.jsx
// import React from "react";
// import {
//  Modal,
//  ModalOverlay,
//  ModalContent,
//  ModalHeader,
//  ModalCloseButton,
//  ModalBody,
//  useDisclosure,
//  Button,
//  Box,
// } from "@chakra-ui/react";
// import MbbsInquiryForm from "./MbbsInquiryForm"; // make sure path is correct

// const MbbsFormModal = () => {
//  const { isOpen, onOpen, onClose } = useDisclosure();

//  return (
//   <Box>
//    <Button colorScheme="blue" onClick={onOpen}>
//     Apply Now
//    </Button>

//    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
//     <ModalOverlay />
//     <ModalContent>
//      {/* <ModalHeader>MBBS Inquiry</ModalHeader> */}
//      <ModalCloseButton />
//      <ModalBody>
//       <MbbsInquiryForm />
//      </ModalBody>
//     </ModalContent>
//    </Modal>
//   </Box>
//  );
// };

// export default MbbsFormModal;
